import { MatDialog } from '@angular/material/dialog';
import { Subject, firstValueFrom } from 'rxjs';
import { ReportTemplateService } from 'src/app/services/reportTemplate.service';
import { ReportTemplate } from 'src/app/models/reportTemplate.model';
import { ToastService } from 'src/app/services/toast.service';
import { TranslateService } from 'src/app/services/translate.service';
import { AuthService } from 'src/app/services/auth.service';
import { splitCamelCase } from 'src/app/_helpers/format-text';
import { ListFilterState } from 'src/app/shared/components/list-filter-toolbar/list-filter-toolbar.component';
import { applyListFilter } from 'src/app/shared/helpers/listOwnershipFilter.helper';

export abstract class ReportTemplateManagerBase {
  availableTemplates: ReportTemplate[] = [];
  filteredTemplates: ReportTemplate[] = [];
  listFilterState: ListFilterState = { search: '', hideShared: false };
  isLoading = false;

  protected readonly destroy$ = new Subject<void>();

  protected abstract get templateEntityType(): string | undefined;

  constructor(
    protected templateService: ReportTemplateService,
    protected toastService: ToastService,
    protected translateService: TranslateService,
    protected authService: AuthService,
    protected dialog: MatDialog
  ) {}

  protected onTemplatesLoaded(): void {}

  protected afterTemplateMutation(templateId: string): void {}

  protected onTemplateDeleted(template: ReportTemplate): void {}

  protected async loadTemplates(): Promise<void> {
    try {
      this.isLoading = true;
      const templates = await firstValueFrom(
        this.templateService.getReportTemplatesByEntityType(this.templateEntityType)
      ) || [];
      this.availableTemplates = templates.map(t => ({ ...t, entityTypeLabel: splitCamelCase(t.entityType) }));
      this.recomputeFilteredTemplates();
      this.onTemplatesLoaded();
    } catch (error) {
      this.availableTemplates = [];
      this.filteredTemplates = [];
      this.toastService.showError(error, this.translateService.getDynamicTranslation('Failed to load templates'));
    } finally {
      this.isLoading = false;
    }
  }

  recomputeFilteredTemplates(): void {
    const currentUserId = this.authService.getCurrentUser()?.userId ?? null;
    this.filteredTemplates = applyListFilter(this.availableTemplates, this.listFilterState, currentUserId, {
      name: (template: ReportTemplate) => template.name,
      createdByUserId: (template: ReportTemplate) => template.createdByUserId,
      isExempt: (template: ReportTemplate) => template.isDefault
    });
  }

  onListFilterChange(state: ListFilterState): void {
    this.listFilterState = state;
    this.recomputeFilteredTemplates();
  }

  trackByTemplateId(_: number, template: ReportTemplate): string {
    return template.id;
  }
}
